/** Policy links shown under the get-started phone form when signup notices are on. */
export interface SignupPolicyLinks {
    termsOfService: string
    privacyPolicy: string
    telehealthInformedConsent: string
    hipaaNotice: string
}

export interface AuthPhoneCopy {
    stepIndicator: string
    title: string
    subtitle: string
    phoneLabel: string
    /** Defaults to General Medicine marketing-site URLs when omitted. */
    policyLinks?: SignupPolicyLinks
}

export interface AuthDateOfBirthCopy {
    stepIndicator: string
    title: string
    subtitle: string
    dateLabel: string
    submitLabel: string
}

export interface AuthVerifyCopy {
    stepIndicator: string
    title: string
    bodyPrefix: string
    bodySuffix: string
    maskPhone: boolean
    codeLabel: string
    submitAction: string
    resendPrompt: string
    resendAction: string
    resendAsLink: boolean
}

export interface AuthReviewInfoCopy {
    stepIndicator: string
    title: string
    subtitle: string
    editAction: string
}

export interface AuthCopy {
    signupPhone: AuthPhoneCopy
    loginPhone: AuthPhoneCopy
    signupDateOfBirth: AuthDateOfBirthCopy
    verify: AuthVerifyCopy
    reviewInfo: AuthReviewInfoCopy
}

export const DEFAULT_SIGNUP_POLICY_LINKS: SignupPolicyLinks = {
    termsOfService: 'https://generalmedicine.co/terms-of-service/',
    privacyPolicy: 'https://generalmedicine.co/privacy-policy/',
    telehealthInformedConsent: 'https://generalmedicine.co/telehealth-informed-consent',
    hipaaNotice: 'https://generalmedicine.co/hipaa-privacy-practices',
}

export const generalMedicineAuthCopy: AuthCopy = {
    signupPhone: {
        stepIndicator: 'Step 1 of 3',
        title: 'Create account',
        subtitle: 'Please enter your mobile phone number:',
        phoneLabel: '',
        policyLinks: DEFAULT_SIGNUP_POLICY_LINKS,
    },
    loginPhone: {
        stepIndicator: '',
        title: 'Sign in',
        subtitle: 'Please enter your mobile phone number:',
        phoneLabel: '',
    },
    signupDateOfBirth: {
        stepIndicator: 'Step 3 of 4',
        title: 'Date of birth',
        subtitle: 'Please enter your date of birth:',
        dateLabel: '',
        submitLabel: 'Continue',
    },
    verify: {
        stepIndicator: 'Step 2 of 3',
        title: 'Check your texts',
        bodyPrefix: 'We sent a 6-digit code to ',
        bodySuffix: '',
        maskPhone: false,
        codeLabel: '',
        submitAction: 'Continue',
        resendPrompt: '',
        resendAction: 'Resend code',
        resendAsLink: false,
    },
    reviewInfo: {
        stepIndicator: 'Step {total} of {total}',
        title: 'Review your info',
        subtitle: "We securely autofilled your information from trusted sources, so you don't have to enter it manually.",
        editAction: 'Edit Information',
    },
}
